/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SubtractInputs */

const en_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract`)
};

const fr_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustraire`)
};

const de_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrahieren`)
};

const it_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrarre`)
};

const ru_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вычесть`)
};

const es_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sustraer`)
};

const zh_cn2_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减去`)
};

const ja_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`減算`)
};

const hi_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटाना`)
};

const pt_pt2_subtract = /** @type {(inputs: SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrair`)
};

/**
* | output |
* | --- |
* | "Subtract" |
*
* @param {SubtractInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtract = /** @type {((inputs?: SubtractInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SubtractInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtract(inputs)
	if (locale === "de") return de_subtract(inputs)
	if (locale === "it") return it_subtract(inputs)
	if (locale === "ru") return ru_subtract(inputs)
	if (locale === "es") return es_subtract(inputs)
	if (locale === "zh-CN") return zh_cn2_subtract(inputs)
	if (locale === "ja") return ja_subtract(inputs)
	if (locale === "hi") return hi_subtract(inputs)
	if (locale === "pt-PT") return pt_pt2_subtract(inputs)
	return en_subtract(inputs)
});